<div class="side-menu">
  <tds-side-menu
    aria-label="Side menu"
    id="side-menu"
    persistent
    open="{{ isMenuOpened }}"
  >
    <tds-side-menu-overlay
      slot="overlay"
      (click)="mobileMenuAction(false)"
    ></tds-side-menu-overlay>
    <tds-side-menu-close-button
      slot="close-button"
      aria-label="Close drawer menu"
      (click)="mobileMenuAction(false)"
    ></tds-side-menu-close-button>
    @for (menu of menus; track menu.title) {
      @if (menu.subMenu) {
        <tds-side-menu-dropdown id="wheel-types-dropdown" default-closed>
          <tds-icon slot="icon" name="{{ menu.icon }}" size="24px"></tds-icon>
          <span slot="label">{{ menu.title }}</span>

          <tds-side-menu-dropdown-list>
            @for (sub of menu.subMenu; track sub.title) {
              @if (
                !sub.locais ||
                (currentLocalId && sub.locais.includes(currentLocalId))
              ) {
                <tds-side-menu-dropdown-list-item
                  [selected]="selectedMenu === sub.path ? true : false"
                >
                  <button (click)="navigate(sub.path)">{{ sub.title }}</button>
                </tds-side-menu-dropdown-list-item>
              }
            }
          </tds-side-menu-dropdown-list>
        </tds-side-menu-dropdown>
      } @else {
        <tds-side-menu-item
          [selected]="selectedMenu === menu.path ? true : false"
        >
          <button (click)="navigate(menu.path)">
            <tds-icon name="{{ menu.icon }}" size="24px"></tds-icon>
            {{ menu.title }}
          </button>
        </tds-side-menu-item>
      }
    }
    <tds-side-menu-dropdown slot="sticky-end" selected>
      <tds-side-menu-user
        slot="label"
        [heading]="this.userService.getUserName() ?? ''"
        [subheading]="this.userService.getUserEmail() ?? ''"
        [attr.img-src]="
          photoUrl
            ? photoUrl
            : 'https://www.svgrepo.com/show/384676/account-avatar-profile-user-6.svg'
        "
        img-alt="Foto do usuário"
      >
      </tds-side-menu-user>
    </tds-side-menu-dropdown>
    <tds-side-menu-collapse-button slot="sticky-end"
      >Minimizar</tds-side-menu-collapse-button
    >
  </tds-side-menu>
</div>
